import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

// Asks before marking a repository as billable. onConfirm runs only on "Yes";
// Cancel, Esc or clicking outside leave the checkbox unchecked.
export default function confirmMarkBillable(onConfirm) {
  confirmAlert({
    overlayClassName: "billable-confirm-overlay",
    customUI: ({ onClose }) => (
      <div
        className="billable-confirm"
        role="dialog"
        aria-labelledby="billable-confirm-title"
      >
        <h4 id="billable-confirm-title">Mark as billable?</h4>
        <p>
          Billable means this is a production repository and will be included
          in billing. Demo repositories should stay unchecked.
        </p>
        <div className="billable-confirm-buttons">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn brand-button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Yes, mark billable
          </button>
        </div>
      </div>
    ),
  });
}
